import React from 'react'
import config from '../../config'

const MenuConfig = [
  [
    [
      config.routes.home,
      'Home',
      'l'
    ],
    [
      config.routes.about,
      'About us',
      'l'
    ],
    [
      config.routes.howitworks,
      'How it works',
      's'
    ],
    [
      config.routes.media,
      'Media',
      's'
    ],
    [
      config.links.contact,
      'Contact us',
      's'
    ],
    [
      config.routes.legal,
      'Legal disclaimer',
      's'
    ],
  ],
  [
    [
      config.routes.clean,
      'Search funds',
      'l',
      'search'
    ],
    // [
    //   config.routes.indexfunds,
    //   'Index funds',
    //   's'
    // ],
    // [
    //   config.routes.targetdate,
    //   'Target date funds',
    //   's'
    // ],
    [
      config.routes.retirementPlans,
      '401(k) plans',
      's'
    ],
    // [
    //   config.routes.fundManagers,
    //   'Fund managers',
    //   'l'
    // ],
    // [
    //   config.routes.fundManager+'/Vanguard',
    //   'Vanguard',
    //   's'
    // ],
    // [
    //   config.routes.fundManager+'/BlackRock%2FiShares',
    //   'BlackRock/iShares',
    //   's'
    // ],
    // [
    //   config.routes.fundManager+'/State%20Street',
    //   'State Street',
    //   's'
    // ],
    // [
    //   config.routes.fundManagers,
    //   'More fund managers',
    //   's'
    // ],
  ],
  [
    [
      config.routes.toolkit,
      'Action toolkit',
      'l'
    ],
    [
      config.links.signup,
      'Sign up',
      'l',
      'envelope-o'
    ],
    [
      config.links.donate,
      'Donate to As You Sow',
      'l',
      'heart'
    ]
  ]
]

export default MenuConfig